// extracted by mini-css-extract-plugin
export default {"box":"box-TBLxw","innerBox":"innerBox-BEEKp","header":"header-TLvhS","descriptionContainer":"descriptionContainer-Bo4lZ","description":"description-BDhhQ","details":"details-bdNb9"};